import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import style from "./Footer.module.scss";
import classnames from "classnames";
import { Mode } from "../../../../utils/Order/Order";
import { Dispatch } from "../store/store";

const Footer = ({ actions, mode, side, buttons, wizzard }) => {
  const { dispatch } = useContext(Dispatch);
  const { precheck, modify, confirm, save } = buttons;

  return (
    <div className={style.footer}>
      <GoStepBack wizzard={wizzard} dispatch={dispatch} />
      <div className={style.buttons}>
        <Button color="light" onClick={actions.toggle}>
          {mode == Mode.EDIT ? "Cancel" : "Close"}
        </Button>{" "}
        {modify.visible && !wizzard.enabled && (
          <Button color="light" onClick={actions.goBack}>
            {"Cancel"}
          </Button>
        )}{" "}
        {modify.visible && !wizzard.enabled && (
          <LaddaButton
            className={"btn btn-ladda btn-light"}
            loading={modify.loading}
            onClick={actions.modify}
            data-style={EXPAND_RIGHT}
          >
            {modify.label || "Modify"}
          </LaddaButton>
          /*
          <Button color="light" onClick={actions.modify}>
            {modify.label || "Modify"}
          </Button>
          */
        )}{" "}
        {save.visible && !wizzard.enabled && (
          <LaddaButton
            className={"btn btn-ladda btn-warning"}
            loading={save.loading}
            onClick={actions.save}
            data-style={EXPAND_RIGHT}
          >
            Save
          </LaddaButton>
        )}{" "}
        {precheck.visible && !wizzard.enabled && (
          <LaddaButton
            className={classnames("btn btn-ladda", side == "Buy" ? style.buy : style.sell)}
            //loading={precheck.loading}
            onClick={() => onChangeMode(dispatch, Mode.PRECHECK)}
            data-style={EXPAND_RIGHT}
          >
            {precheck.label || "	Pre check"}
          </LaddaButton>
        )}{" "}
        {wizzard.enabled && wizzard.nextBtn.visible && (
          <LaddaButton
            className={classnames("btn btn-ladda", side == "Buy" ? style.buy : style.sell)}
            loading={wizzard.nextBtn.loading || confirm.loading}
            onClick={actions.nextStep}
            data-style={EXPAND_RIGHT}
          >
            {wizzard.nextBtn.label}
          </LaddaButton>
        )}{" "}
        {confirm.visible && !wizzard.enabled && (
          <LaddaButton
            className={classnames("btn btn-ladda", side == "Buy" ? style.buy : style.sell)}
            loading={confirm.loading}
            onClick={actions.confirm}
            data-style={EXPAND_RIGHT}
          >
            {confirm.label}
          </LaddaButton>
        )}
      </div>
    </div>
  );
};

const onChangeMode = (dispatch, mode) => dispatch({ type: "CHANGE_MODE", mode });

const GoStepBack = ({ wizzard, dispatch }) => {
  if (wizzard.enabled && wizzard.activeStep != 0) {
    return (
      <Button color="light" onClick={() => dispatch({ type: "WIZZ_STEP_BACK" })}>
        <i className="fa fa-angle-left"></i>
        {"\u00A0"}
        Back
      </Button>
    );
  } else return null;
};

export default Footer;
